<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/receipt-order";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Delivery Orders",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('receipt_orders.singular')) }},
    resourceRoute: {default: 'receipt_orders'},
    modelVariable: {default: 'receipt_order'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('receipt_orders.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
          href: "/receipt_orders",
        },
        {
          text: this.model && this.model.id ? this.model['order_id'] : this.$route.params.key,
          href: `/receipt_orders/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/receipt_orders/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    getModelName() {
      return this.model['order_id'];
    },
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/receipt_orders/${this.$route.params.key}`, {
        params: {
          with: 'receipt_items'
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/receipt_orders/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/receipt_orders/${this.$route.params.key}`)
    }
  }
}
</script>
